import React from 'react';
import classNames from 'classnames';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import amber from '@material-ui/core/colors/amber';

import { getBidTotals } from 'utils';

const styles = theme => ({
  root: {
    margin: theme.spacing.unit*2,
  },
  background: {
    backgroundColor: amber[50],
  },
  avatar: {
    margin: theme.spacing.unit*2,
    color: '#fff',
    backgroundColor: amber[500],
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  content: {
    marginLeft: theme.spacing.unit*9,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit,
  },
  totals: {
    flexBasis: '250px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit,
  },
  divider: {
    marginBottom: theme.spacing.unit,
  },
});

//TODO: remove business logic that calculates totals, should be done in Bids
// but unfortunately bids and its tasks was denormalized. Either refactor the bids
//state to be normalized or create helper functions/class to do this.
const SummaryCard = ({ classes, title, color, bidTasks }) => {
  const totals = getBidTotals(bidTasks);

  return(
    <Card className={classNames(classes.root, color && classes.background)}>
      <div className={classes.header}>
        <Avatar className={classes.avatar}>{title.substring(0,1).toUpperCase()}</Avatar>
        <Typography variant="headline">{title}</Typography>
      </div>
      <div className={classes.content}>
        {bidTasks.map((bidTask, i) => {
          return(
            <div key={i}>
              <div className={classes.labelField}>
                <Typography>{bidTask.title}</Typography>
                <Typography>${bidTask.subtotal.toFixed(2)}</Typography>
              </div>
              <Divider className={classes.divider} />
            </div>
          );
        })}
      </div>
      <div className={classes.footer}>
        <div />
        <div className={classes.totals}>
          <div className={classes.labelField}>
            <Typography>Subtotal</Typography>
            <Typography>${totals.subtotal.toFixed(2)}</Typography>
          </div>
          <div className={classes.labelField}>
            <Typography>Tax (5%)</Typography>
            <Typography>${totals.tax.toFixed(2)}</Typography>
          </div>
          <Divider className={classes.divider} />
          <div className={classes.labelField}>
            <Typography>Total</Typography>
            <Typography>${totals.total.toFixed(2)}</Typography>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default withStyles(styles)(SummaryCard);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/SummaryCard.jsx